import { takeLatest, put } from 'redux-saga/effects';
import { actions as driverStatisticsActions } from '../slices/DriverStatisticsSlice';
import { actions as employeeStatisticsActions } from '../slices/EmployeeStatisticsSlice';
import { actions as tripStatisticsActions } from '../slices/TripStatisticsSlice';
import { actions as subscriptionCardStatisticsActions } from '../slices/SubscriptionCardStatisticsSlice';
import { actions as staffPaymentStatisticsActions } from '../slices/StaffPaymentStatisticsSlice';
import { actions as aggregatePaymentStatisticsActions } from '../slices/AggregatePaymentStatisticsSlice';
import { actions as monthlyTicketMonth } from '../slices/MonthlyTicketReportSlice';
import { actions as printActions } from '../slices/PrintSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';

function* getDriverStatisticsReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/schedules`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: driverStatisticsActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: driverStatisticsActions.get_list_failed.type, payload: error });
    }
}

function* exportDriverStatisticsReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/schedules`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: driverStatisticsActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: driverStatisticsActions.export_list_failed.type, payload: error });
    }
}

function* getEmployeeStatisticsyReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/staffs`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: employeeStatisticsActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: employeeStatisticsActions.get_list_failed.type, payload: error });
    }
}

function* getTripStatisticsReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/routes/${filters.route_id}/trips`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });

        const { details, items } = response.data;

        const mapData = items.map((item) => {
            return {
                ...item,
                details: details.filter((d) => d.trip_code === item.trip_code),
            };
        });

        yield put({ type: tripStatisticsActions.get_list_succeed.type, payload: { ...response.data, items: mapData } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripStatisticsActions.get_list_failed.type, payload: error });
    }
}

function* exportTripStatisticsyReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/routes/${filters.route_id}/trips`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: tripStatisticsActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripStatisticsActions.export_list_failed.type, payload: error });
    }
}

function* exportEmployeeStatisticsyReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statistic')}/staffs`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: employeeStatisticsActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: employeeStatisticsActions.export_list_failed.type, payload: error });
    }
}

function* getSubscriptionCardStatisticsReport({ payload: { page, size, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/subscription-order/card`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: size,
            },
        });
        yield put({ type: subscriptionCardStatisticsActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: subscriptionCardStatisticsActions.get_list_failed.type, payload: error });
    }
}

function* exportSubscriptionCardStatisticsReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/subscription-order/card`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: subscriptionCardStatisticsActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: subscriptionCardStatisticsActions.export_list_failed.type, payload: error });
    }
}

function* getStaffPaymentStatisticsReport({ payload: { page, size, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/employee`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: size,
            },
        });
        yield put({ type: staffPaymentStatisticsActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: staffPaymentStatisticsActions.get_list_failed.type, payload: error });
    }
}

function* exportStaffPaymentStatisticsReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/employee`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: staffPaymentStatisticsActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: staffPaymentStatisticsActions.export_list_failed.type, payload: error });
    }
}

function* getAggregatePaymentStatisticsReport({ payload: { page, size, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/staff`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: size,
            },
        });
        yield put({ type: aggregatePaymentStatisticsActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: aggregatePaymentStatisticsActions.get_list_failed.type, payload: error });
    }
}

function* exportAggregatePaymentStatisticsReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/staff`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: aggregatePaymentStatisticsActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: aggregatePaymentStatisticsActions.export_list_failed.type, payload: error });
    }
}

function* getAggregatePaymentStatisticsReportForPrint({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/staff`, {
            params: {
                ...filters,
                is_print: true,
            },
        });
        yield put({ type: printActions.get_print_aggregate_payment_statistics_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: printActions.get_print_aggregate_payment_statistics_failed.type, payload: error });
    }
}

function* getStaffPaymentStatisticsReportForPrint({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_statement')}/employee`, {
            params: {
                ...filters,
                is_print: true,
            },
        });
        yield put({ type: printActions.get_print_staff_payment_statistics_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: printActions.get_print_aggregate_payment_statistics_failed.type, payload: error });
    }
}


function* getListMonthlyTicketReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('monthly_ticket_report')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: monthlyTicketMonth.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: monthlyTicketMonth.get_list_failed.type, payload: error });
    }
}

function* exportMonthlyTicketReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('monthly_ticket_report')}`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: monthlyTicketMonth.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: monthlyTicketMonth.export_list_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(tripStatisticsActions.get_list.type, getTripStatisticsReport);
    yield takeLatest(tripStatisticsActions.export_list.type, exportTripStatisticsyReport);
    yield takeLatest(driverStatisticsActions.get_list.type, getDriverStatisticsReport);
    yield takeLatest(driverStatisticsActions.export_list.type, exportDriverStatisticsReport);
    yield takeLatest(employeeStatisticsActions.get_list.type, getEmployeeStatisticsyReport);
    yield takeLatest(employeeStatisticsActions.export_list.type, exportEmployeeStatisticsyReport);
    yield takeLatest(subscriptionCardStatisticsActions.get_list.type, getSubscriptionCardStatisticsReport);
    yield takeLatest(subscriptionCardStatisticsActions.export_list.type, exportSubscriptionCardStatisticsReport);
    yield takeLatest(staffPaymentStatisticsActions.get_list.type, getStaffPaymentStatisticsReport);
    yield takeLatest(staffPaymentStatisticsActions.export_list.type, exportStaffPaymentStatisticsReport);
    yield takeLatest(aggregatePaymentStatisticsActions.get_list.type, getAggregatePaymentStatisticsReport);
    yield takeLatest(aggregatePaymentStatisticsActions.export_list.type, exportAggregatePaymentStatisticsReport);
    yield takeLatest(printActions.get_print_aggregate_payment_statistics.type, getAggregatePaymentStatisticsReportForPrint);
    yield takeLatest(printActions.get_print_staff_payment_statistics.type, getStaffPaymentStatisticsReportForPrint);
    yield takeLatest(monthlyTicketMonth.get_list.type, getListMonthlyTicketReport);
    yield takeLatest(monthlyTicketMonth.export_list.type, exportMonthlyTicketReport);
}

export default watchRequestDetail;
